import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router';

// Images
import logoImg from '@assets/images/site-logo.svg';
import logodarkImg from '@assets/images/site-logo-dark.svg';
import siteLogoTatva from '@assets/images/site-logo-tatva.svg';
// Components
import CustomButton from '../../components/CustomButton';

// Prime-React Components
import CustomPassword from '../../components/CustomPassword';
import { classNames } from 'primereact/utils';

// Redux-Actions
import { resetPassword } from '../../redux/actions/auth';

// Redux-Slices
import { apiStatusClear } from '../../redux/slices/apiStatus';

// Constants
import { BUTTON_TYPES, LABEL_TYPES, ROUTES } from '../../constants/common';
import { resetPasswordSchema } from '../../schema/auth.schema';
import { getFormErrorMessage, isFormFieldValid } from '../../utils/common';

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isSucceed, isLoading } = useSelector((state) => state.apiStatus);
  const { token } = useParams();
  const resetPasswordInitialValues = {
    password: '',
    confirmPassword: '',
    token: token
  };

  useEffect(() => {
    if (isSucceed) {
      navigate(ROUTES.LOGIN);
      dispatch(apiStatusClear());
    }
  }, [isSucceed, navigate, dispatch]);

  const formik = useFormik({
    initialValues: resetPasswordInitialValues,
    validationSchema: resetPasswordSchema,
    onSubmit: () => handleSubmit()
  });

  const handleSubmit = () => {
    try {
      dispatch(resetPassword(formik.values));
      isSucceed && formik.resetForm();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="authentication-wrapper reset-pwd">
      <div className="tatva-logo-wrap">
        <img src={siteLogoTatva} alt="Tatvasoft" />
      </div>
      <div className="authentication-inner">
        <div className="login-container">
          <span className="site-logo">
            <img src={logoImg}></img>
            <img src={logodarkImg} className="dark-theme-logo"></img>
          </span>
          <h2>Reset Password</h2>
          <form onSubmit={formik.handleSubmit} className="p-fluid">
            <div className="field">
              <CustomPassword
                htmlFor="password"
                text={LABEL_TYPES.NEW_PASSWORD}
                ismandatory={+true}
                isbold={+true}
                id="password"
                name="password"
                placeholder="New Password *"
                value={formik.values.password}
                onChange={formik.handleChange}
                toggleMask
                className={classNames({
                  'p-invalid': isFormFieldValid(formik, 'password')
                })}
                feedback={false}
              />
              {getFormErrorMessage(formik, 'password')}
            </div>
            <div className="field">
              <CustomPassword
                htmlFor="confirmPassword"
                text={LABEL_TYPES.CONFIRM_PASSWORD}
                ismandatory={+true}
                isbold={+true}
                id="confirmPassword"
                name="confirmPassword"
                placeholder="Confirm Password *"
                value={formik.values.confirmPassword}
                onChange={formik.handleChange}
                toggleMask
                className={classNames({
                  'p-invalid': isFormFieldValid(formik, 'confirmPassword')
                })}
                feedback={false}
              />
              {getFormErrorMessage(formik, 'confirmPassword')}
            </div>
            <CustomButton type="submit" variant="contained" className="w-full" disabled={isLoading}>
              {BUTTON_TYPES.SAVE}
            </CustomButton>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
